"use client";

import { useState } from "react";
import { useSession } from "next-auth/react";
import { Flag, X, Loader2 } from "lucide-react";

interface ReportButtonProps {
    inbId: string;
}

export default function ReportButton({ inbId }: ReportButtonProps) {
    const { data: session } = useSession();
    const [isOpen, setIsOpen] = useState(false);
    const [reason, setReason] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    const handleSubmit = async () => {
        if (!reason.trim()) return;

        setIsLoading(true);
        try {
            const response = await fetch("/api/reports", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ inbId, reason }),
            });

            if (response.ok) {
                setSubmitted(true);
                setTimeout(() => {
                    setIsOpen(false);
                    setSubmitted(false);
                    setReason("");
                }, 2000);
            }
        } catch (error) {
            console.error("Error submitting report:", error);
        } finally {
            setIsLoading(false);
        }
    };

    if (!session) {
        return null;
    }

    if (submitted) {
        return (
            <div className="text-green-500 text-sm flex items-center gap-2">
                ✓ Zgłoszenie wysłane
            </div>
        );
    }

    return (
        <>
            <button
                onClick={() => setIsOpen(true)}
                className="flex items-center gap-2 text-gray-500 hover:text-red-600 transition-colors text-sm"
            >
                <Flag size={16} />
                Zgłoś
            </button>

            {isOpen && (
                <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4">
                    <div className="card max-w-md w-full p-6">
                        <div className="flex items-center justify-between mb-4">
                            <h3 className="text-lg font-semibold">Zgłoś inbe</h3>
                            <button
                                onClick={() => setIsOpen(false)}
                                className="text-gray-400 hover:text-white"
                            >
                                <X size={20} />
                            </button>
                        </div>

                        <textarea
                            value={reason}
                            onChange={(e) => setReason(e.target.value)}
                            placeholder="Opisz powód zgłoszenia..."
                            className="input min-h-[100px] resize-y mb-4"
                            maxLength={500}
                        />

                        <div className="flex gap-3">
                            <button
                                onClick={() => setIsOpen(false)}
                                className="btn btn-ghost flex-1"
                            >
                                Anuluj
                            </button>
                            <button
                                onClick={handleSubmit}
                                disabled={!reason.trim() || isLoading}
                                className="btn btn-primary flex-1 flex items-center justify-center gap-2"
                            >
                                {isLoading ? (
                                    <Loader2 className="animate-spin" size={16} />
                                ) : (
                                    "Wyślij zgłoszenie"
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
